import { CaretRightOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Dropdown,
  Menu,
  Modal,
  Row,
  Tooltip,
  message,
} from "antd";
// import Base from "antd/lib/typography/Base";
import { MoreOutlined } from "@ant-design/icons";
import { pdf } from "@react-pdf/renderer";
import { DatePicker } from "antd";
import { saveAs } from "file-saver";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import Close from "../../assets/icons/close.png";
import credit from "../../assets/icons/credit.png";
import debit from "../../assets/icons/debit.png";
import reversal from "../../assets/icons/reversal.svg";
import sync from "../../assets/icons/sync.png";
import { apis } from "../../config/APIs";
import endpoint from "../../config/Axios";
import { amountFormat, capitalize } from "../../utils";
import BaseCurrency from "../Common/BaseCurrency";
import { savePdfFromBase64 } from "../Common/DownloadAll";
import Table from "../Common/Table/Table";
import {
  Transactions,
  cardsDetails,
  transactions,
} from "./../../actions/cards/cards";
import ReportDisputeModal from "./RaiseDisputeModal";
import TxnPDF from "./TxnPdf";
import "./card.css";

const TransactionsAccordion = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { cardData = {} } = props;
  const {
    location: { state: { viewTxns = false } = {} },
  } = history;
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [refresh, setRefresh] = React.useState(false);
  const [page, setPage] = React.useState(1);
  const [transData, setTransData] = React.useState([]);
  const [exportLoading, setExportLoading] = React.useState(false);
  const [isModalDispute, setIsModalDispute] = React.useState(false);
  const [selectedKey, setSelectedKey] = useState("");
  const [selectedTxType, setSelectedTxType] = useState("");
  const [selectedDateRange, setSelectedDateRange] = useState([]);

  const transactionsResponse = useSelector(
    (state) => state.cards.transactions || {}
  );
  const cards_export = useSelector(
    (state) => state.analytics.analytics_cards_export
  );
  const is_admin = useSelector(
    (state) => state?.auth?.localVariables?.is_admin
  );

  useEffect(() => {
    if (viewTxns) {
      handleButtiClick();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewTxns]);

  React.useEffect(() => {
    const {
      data: {
        response: { transactions = [] } = {},
        status = "",
        message: msg = "",
      } = {},
    } = transactionsResponse;
    if (status) {
      setTransData(transactions);
      if (refresh) {
        dispatch(cardsDetails({ card_id: cardData?.id }));
        setRefresh(false);
      }
    } else if (status === false) {
      message.success(
        <span className="messageText">
          {msg === "Transaction not found"
            ? "There are no transactions to display at present."
            : msg}
        </span>
      );
      dispatch({
        type: Transactions.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transactionsResponse]);

  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedTxType("");
    setSelectedDateRange([null, null]);
    setSelectedKey("");
  };

  const handleButtiClick = () => {
    setIsModalVisible(true);
    if (cardData.id) {
      dispatch(
        transactions({
          card_id: cardData.id,
          refresh: true,
          sort_key: "transaction_date",
        })
      );
      dispatch(cardsDetails({ card_id: cardData?.id }));
    }
  };

  const downloadPdf = async (data = []) => {
    const blob = await pdf(
      <TxnPDF data={data} cardData={cardData} walletData={props.walletData} />
    ).toBlob();
    saveAs(blob, "Transactions.pdf");
  };

  // const downloadPdf = async (data = []) => {
  //   try {
  //     const blob = await pdf(
  //       <TxnPDF data={data} cardData={cardData} walletData={props.walletData} />
  //     ).toBlob();

  //     // Create a Blob URL and download
  //     const url = URL.createObjectURL(blob);
  //     const a = document.createElement('a');
  //     a.href = url;
  //     a.download = 'Transactions.pdf';
  //     document.body.appendChild(a);
  //     a.click();
  //     document.body.removeChild(a);

  //     // Revoke the Blob URL to free memory
  //     URL.revokeObjectURL(url);
  //   } catch (error) {
  //     console.error('Error generating PDF:', error);
  //   }
  // };

  const modalColumns = [
    {
      title: "Transaction ID",
      dataIndex: "vendor_transaction_id",
      key: "vendor_transaction_id",
    },
    {
      title: "Date & Time",
      dataIndex: "transaction_date",
      key: "transaction_date",
    },
    // {
    //   title: "Terminal ID",
    //   dataIndex: "terminalId",
    //   key: "terminalId",
    // },
    // {
    //   title: "Wallet Type",
    //   dataIndex: "remaining",
    //   key: "remaining",
    //   render: (text) => <div>Meal Wallet</div>,
    // },
    {
      // title: "Merchant Name",
      title: "Transaction Details",
      dataIndex: "merchant",
      key: "merchant",
      render: (text) => (
        <Tooltip title={text}>
          <span
            style={{
              whiteSpace: "pre",
              color: "#454545",
              maxWidth: "13rem",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "inline-block",
            }}
          >
            {text}
          </span>
        </Tooltip>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text, record) => (
        <div>
          <img
            src={
              record?.transaction_type === "reversal"
                ? reversal
                : record?.transaction_type === "credit"
                ? credit
                : debit
            }
            width={10}
            alt="credit"
          />{" "}
          <BaseCurrency /> {amountFormat(text)}
        </div>
      ),
    },
    {
      title: "Wallet Name",
      dataIndex: "wallet_name",
      key: "wallet_name",
    },
    {
      title: "Transaction Nature",
      dataIndex: "channelType",
      key: "channelType",
      render: (text, record) => <div>{record?.data?.txnType}</div>,
    },
  ];

  if (!is_admin && modalColumns.length == 6) {
    modalColumns.push({
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Dropdown
          overlay={
            <Menu>
              {is_admin ? null : (
                <Menu.Item key="1" onClick={() => handleRaiseDispute(record)}>
                  Raise Dispute
                </Menu.Item>
              )}
            </Menu>
          }
          trigger={["click"]}
        >
          <Button icon={<MoreOutlined />} />
        </Dropdown>
      ),
    });
  }

  const handleRaiseDispute = (key) => {
    console.log("Raise dispute for:", key);
    setIsModalDispute(key);
    setIsModalVisible(false);
    // Implement your dispute raising logic here
  };

  const items = [
    { key: "", label: "All" },
    { key: "last_10", label: "Last 10 transactions" },
    { key: "weekly", label: "Last 7 days" },
    { key: "monthly", label: "Last 30 days" },
    { key: "quarterly", label: "Last 3 Months" },
    { key: "custom", label: "Custom" },
  ];

  const menu = (
    <Menu
      onClick={(e) => {
        const today = moment();
        let dates = [];
        switch (e.key) {
          case "last_10":
            dates = [
              today.clone().subtract(10, "days").format("YYYY-MM-DD"),
              today.format("YYYY-MM-DD"),
            ];
            break;
          case "weekly":
            dates = [
              today.clone().subtract(1, "week").format("YYYY-MM-DD"),
              today.clone().format("YYYY-MM-DD"),
            ];
            break;
          case "monthly":
            dates = [
              today.clone().subtract(1, "month").format("YYYY-MM-DD"),
              today.clone().format("YYYY-MM-DD"),
            ];
            break;
          case "quarterly":
            dates = [
              today.clone().subtract(90, "days").format("YYYY-MM-DD"),
              today.clone().format("YYYY-MM-DD"),
            ];
            break;
          case "custom":
            // Handle custom date selection logic here
            dates = [null, null]; // Placeholder for custom date range
            break;
          default:
            dates = [null, null];
            break;
        }

        setSelectedKey(e.key);
        if (e.key !== "custom") {
          setPage(1);
          setSelectedDateRange(dates);
          dispatch(
            transactions({
              page: 1,
              card_id: cardData.id,
              refresh: true,
              sort_key: "transaction_date",
              period: e.key,
              start_date: dates[0] ? dates[0] : null,
              end_date: dates[1] ? dates[1] : null,
              transaction_type: selectedTxType ? selectedTxType : undefined,
            })
          );
        } else {
          setSelectedDateRange([]);
        }
      }}
      items={[...items]}
    />
  );

  useEffect(() => {
    if (
      selectedKey === "custom" &&
      selectedDateRange?.[0] &&
      selectedDateRange?.[1]
    ) {
      setPage(1);
      dispatch(
        transactions({
          page: 1,
          card_id: cardData.id,
          refresh: true,
          sort_key: "transaction_date",
          period: selectedKey,
          start_date: selectedDateRange?.[0]
            ? selectedDateRange?.[0].format("YYYY-MM-DD")
            : null,
          end_date: selectedDateRange?.[1]
            ? selectedDateRange?.[1].format("YYYY-MM-DD")
            : null,
          transaction_type: selectedTxType ? selectedTxType : undefined,
        })
      );
    }
  }, [selectedDateRange, selectedKey]);

  const renderModal = () => {
    return (
      <>
        <span
          className="cursor"
          onClick={() => {
            handleCancel();
          }}
          style={{ position: "absolute", right: 10, top: 10 }}
        >
          <img src={Close} width={20} alt={"close"} />
        </span>
        <Row>
          <Col className="mb2" span={4}>
            <div className="modalContent">
              <h3>Name</h3>
              <span className="mr1">{cardData?.employee_details?.name}</span>
            </div>
          </Col>
          <Col span={4}>
            <div className="modalContent">
              <h3>Available Balance </h3>
              <span>
                <BaseCurrency /> {amountFormat(cardData?.balance)}
              </span>
            </div>
          </Col>
        </Row>
        <Row
          className="mb2"
          style={{
            gap: "1rem",
          }}
        >
          {props?.walletData.map((item) => (
            <Col span={4} key={item.wallet_identifier}>
              <div className="modalContent">
                <h3>{capitalize(item.wallet_name)}</h3>
                <span>
                  <BaseCurrency /> {amountFormat(item.balance)}
                </span>
              </div>
            </Col>
          ))}
          <Col span={4}>
            <div className="modalContent">
              <h3>Transit Queue Wallet</h3>
              <span>
                <BaseCurrency />{" "}
                {amountFormat(props.cardData?.data?.transitQueue)}
              </span>
            </div>
          </Col>
        </Row>
        {/* {transactionsResponse?.loading && !refresh && !transData?.length ? ( */}

        <Table
          rowKey="id"
          columns={modalColumns}
          data={transData}
          loading={transactionsResponse?.loading}
          placeholder={"Search By Transaction ID, Name"}
          pagination={{
            current: page,
            total: transactionsResponse?.data?.total_records || 0,
            onChange: (pagee) => {
              const startDate = selectedDateRange?.[0]
                ? selectedDateRange?.[0].format
                  ? selectedDateRange?.[0].format("YYYY-MM-DD")
                  : selectedDateRange?.[0]
                : null;
              const endDate = selectedDateRange?.[1]
                ? selectedDateRange?.[1].format
                  ? selectedDateRange?.[1].format("YYYY-MM-DD")
                  : selectedDateRange?.[1]
                : null;
              dispatch(
                transactions({
                  page: pagee,
                  card_id: cardData.id,
                  refresh: true,
                  sort_key: "transaction_date",
                  period: selectedKey,
                  start_date: startDate,
                  end_date: endDate,
                  transaction_type: selectedTxType ? selectedTxType : undefined,
                })
              );
              setPage(pagee);
            },
          }}
          btnsOnly={true}
          btnsComponent={
            <>
              {selectedKey === "custom" ? (
                <>
                  <DatePicker
                    format="DD-MM-YYYY"
                    disabledDate={(current) => {
                      return current && current > moment().endOf("day");
                    }}
                    onChange={(value) => {
                      setSelectedDateRange([value]);
                    }}
                    style={{ marginRight: "1rem" }}
                    placeholder="Start Date"
                  />
                  <DatePicker
                    format="DD-MM-YYYY"
                    disabledDate={(current) => {
                      return (
                        (current && current > moment().endOf("day")) ||
                        moment(selectedDateRange[0]) > current
                      );
                    }}
                    disabled={!selectedDateRange?.[0]}
                    onChange={(value) => {
                      setSelectedDateRange((val) => [val[0], value]);
                    }}
                    style={{ marginRight: "1rem" }}
                    placeholder="End Date"
                  />
                </>
              ) : null}
              <Dropdown overlay={menu} trigger={["click"]}>
                <button className="transaction-filter-dropdown">
                  {selectedKey
                    ? items.find((item) => item.key === selectedKey)?.label
                    : "Advanced Search"}
                </button>
              </Dropdown>
              <button
                className="nm-btn ml1"
                disabled={cards_export?.loading || !transData.length}
                onClick={() => {
                  setExportLoading(true);
                  endpoint
                    .get(apis.export_transactions, {
                      params: {
                        page: 1,
                        per: 100000,
                        // export_card: true,
                        card_id: cardData.id,
                        refresh: true,
                        sort_key: "transaction_date",
                        period: selectedKey,
                        start_date: selectedDateRange?.[0],
                        end_date: selectedDateRange?.[1],
                        format: "pdf",
                      },
                    })
                    .then((res) => {
                      setExportLoading(false);
                      savePdfFromBase64(
                         res?.data?.response,
                        "Transaction.pdf"
                      );
                    })
                    .catch(() => {
                      setExportLoading(false);
                    });
                }}
              >
                {exportLoading ? "Exporting" : "Export"} PDF
              </button>
              <button
                className="ml1 nm-btn"
                onClick={() => {
                  if (cardData.id) {
                    dispatch(
                      transactions({
                        card_id: cardData.id,
                        refresh: true,
                        sort_key: "transaction_date",
                      })
                    );
                    setRefresh(true);
                    setPage(1);
                    setSelectedKey("");
                    setSelectedDateRange([]);
                  }
                }}
                disabled={transactionsResponse?.loading || refresh}
              >
                <img
                  src={sync}
                  alt=""
                  width="14"
                  className={`${
                    transactionsResponse?.loading || refresh
                      ? "mr1 rotating"
                      : "mr1"
                  }`}
                />
                Refresh
              </button>
            </>
          }
          topFilters={[
            { label: "All", filter: "" },
            { label: "Debit", filter: "debit" },
            { label: "Credit", filter: "credit" },
            { label: "Reversal", filter: "reversal" },
          ]}
          isTopTxFilter={true}
          handleFilter={(val) => {
            setSelectedTxType(val);
            setPage(1);
            dispatch(
              transactions({
                page: 1,
                card_id: cardData.id,
                refresh: true,
                sort_key: "transaction_date",
                period: selectedKey,
                start_date: selectedDateRange?.[0],
                end_date: selectedDateRange?.[1],
                transaction_type: val ? val : undefined,
              })
            );
          }}
        />
      </>
    );
  };

  return (
    <>
      {isModalVisible && (
        <Modal
          title="Transaction History"
          visible={isModalVisible}
          onCancel={handleCancel}
          footer={[]}
          className="right-alinged-modal big"
          width={800}
          closable={false}
          maskClosable={false}
        >
          {renderModal()}
        </Modal>
      )}
      {isModalDispute && (
        <ReportDisputeModal
          visible={isModalDispute}
          onCancel={() => {
            setIsModalVisible(true);
            setIsModalDispute(false);
          }}
        />
      )}
      <div className="p1 transactionMenu" onClick={() => handleButtiClick()}>
        <button className="panelButton accordion-heading">
          Transaction History
        </button>
        <CaretRightOutlined rotate={0} className="panelIcon cursor" />
      </div>
    </>
  );
};

export default TransactionsAccordion;
